import { render, staticRenderFns } from "./RolesAddEdit.vue?vue&type=template&id=98b190bc&scoped=true&"
import script from "./RolesAddEdit.vue?vue&type=script&lang=js&"
export * from "./RolesAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./RolesAddEdit.vue?vue&type=style&index=0&id=98b190bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b190bc",
  null
  
)

export default component.exports